<template>
  <filter-controller
    :receive="allProps.receive"
    :all="allProps.result && allProps.result.items"
    :permanent="permanent"
    :parameters="parameters"
    v-bind="$attrs"
    :loading="allProps.loading || false"
    :value="value"
    @input="handleFilter"
  >
    <template #append="scope">
      <slot name="append" v-bind="scope" />
    </template>
  </filter-controller>
</template>

<script setup lang="ts">
import FilterController from './FilterController.vue'

const props = defineProps<{
  value?: any
  allProps?: any
  availableProps?: any
  permanent?: any
  parameters?: any
}>()

const emit = defineEmits<{
  input: [p: any]
}>()

function handleFilter(parameters: any) {
  emit('input', parameters)
}
</script>
